export class SImage {
    alias = 0;
    allowLandscape = false;
    allowPortrait = false;
    allow600 = false;
    caption = '';
    crop;
    alt = '';
    filename = '';
    height = 0;
    gettyCaption = '';
    gettyId = '';
    id = 0;
    sizes = {};
    title = '';
    oldTitle = '';
    url = '';
    urlWithParams = '';
    width = 0;
    slides = [];
    techniques = {};

    constructor(image) {
        for(var prop in image) {
            if (image[prop]) {
                this[prop] = image[prop];
            }
        }

        this.oldTitle = this.title;

        this.urlWithParams = this.getUrl(this.url);
        this.urlWithParams = this.url + this.getParams('');
        let sizes = Object.keys(this.sizes);
        for(var i = 0; i < sizes.length; i++) {
            const size = sizes[i];
            if( this.sizes[size].url ) {
                this.sizes[size].url = this.getUrl(this.sizes[size].url);
            }
            this.sizes[size].urlWithParams = this.url + this.getParams(size);
        }
        this.setAllowPortrait();
        this.setAllowLandscape();
        this.setAllow600();
    }
    setAllowLandscape() {
        const mobileSize = this.sizes['mobile'];
        this.allowLandscape = this.allowLandscape || !mobileSize || (mobileSize.width != 480 && mobileSize.height != 720);
    }
    setAllowPortrait() {
        let desktopSize = this.sizes['desktop'];
        if( desktopSize && desktopSize.crop ) {
            desktopSize = desktopSize.crop;
        }
        this.allowPortrait = this.allowPortrait || !desktopSize || (desktopSize.width != 800 && desktopSize.height != 533)
    }
    setAllow600() {
        let desktopSize = this.sizes['desktop'];
        if( desktopSize && desktopSize.crop ) {
            desktopSize = desktopSize.crop;
        }
        this.allow600 = this.width < 800 && (!desktopSize || desktopSize.width < 800);
        if( this.allow600 ) {
            this.allowPortrait = false;
        }
    }
    getParams(size) {
        let image = this;
        if( size !== '' ) {
            image = this.sizes[size];
        }
        if( image.crop ) {
            return this.buildHttpParams(image.crop);
        }
        return this.buildHttpParams(image);
    }
    buildHttpParams(params) {
        const queryParams = ['width', 'height', 'top', 'left', 'zoom', 'b', 'c'];
        let httpParams = [];
        for(var i = 0; i < queryParams.length; i++) {
            const param = queryParams[i];
            const value = params[param];
            if( value ) {
                httpParams.push(param + '=' + value);
            }
        }
        return httpParams.length > 0 ? '?' + httpParams.join('&') + '&v=' + new Date().getTime() : '';
    }
    getUrl(url) {
        return url.replace(/^https:|^http:/, window.location.protocol);
    }
}